<div class="modal-header modal-pepsico-header">
  <h1 class="modal-title fs-5" id="exampleModalLabel">Mi Avance</h1>
  <button class="btn-close color-white" (click)="closeModal()"></button>
</div>
<div class="modal-body text-center">
  <div class="order-tracking-unique">
    <ul class="nav nav-tabs" id="avanceTab" role="tablist">
    </ul>
    <div class="tab-content mb-0 mt-4" id="avanceTabContent">
      <div class="tab-pane fade show active" id="cae-tab-pane" role="tabpanel" aria-labelledby="cae-tab" tabindex="0">

        <div class="row">
          @if(isLoading()) {
          <div class="col-12 d-flex justify-content-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          } @else {
          @for (contest of contests(); track contest.id) {
          <div class="col-lg-4 mb-3">
            <div class="card bgBlue" #card>
              <div class="card-front">
                <div class="title">
                  <p class="name">{{ contest.name }}</p>
                </div>
                <img [src]="contest.pathImage" alt="" class="imgGoal">
                @if(contest.subContests.length > 0) {
                <button class="btn btn-primary btn-flip" (click)="flipCard(card)">Ver indicadores</button>
                }
              </div>
              <div class="card-back">
                <div class="title d-flex justify-content-between mb-3">
                  <p class="name">{{ contest.name }}</p>
                  <button class="btn btn-flip-back" (click)="removeFlipCard(card)">
                    <img src="assets/images/icon/back.svg" alt="">
                  </button>
                </div>
                <div class="progreso-wrap">
                  @for (subContest of contest.subContests; track subContest.subContestId) {
                  <div class="progreso mb-3">
                    <p>Indicador: {{ subContest.name }}</p>
                    <table class="tableProgress">
                      <tbody>
                        <tr>
                          <td>Objetivo</td>
                          <td>{{subContest.goal | number}}%</td>
                        </tr>
                        <tr>
                          <td>Avance</td>
                          <td>{{subContest.progress | number}}%</td>
                        </tr>
                        <tr>
                          <td>Diferencia</td>
                          <td>{{subContest.difference | number}}PP</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="progress" role="progressbar" aria-label="" aria-valuenow="75" aria-valuemin="0"
                      aria-valuemax="100">
                      <div class="progress-bar" [style.width]="getProgressWidth(subContest.goal, subContest.progress)">
                      </div>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          } @empty {
          <div class="col-12 d-flex justify-content-center">
            Actualmente no hay concursos
          </div>
          }

          }
        </div>
      </div>
    </div>

  </div>

</div>
<div class="modal-footer jf-center">
  <button type="button" class="btn btn-primary perfilbtn-pep mx-auto" (click)="closeModal()">
    Cerrar
  </button>
</div>